export { default } from './RenderGuard';
